export const updateObject = (oldState:any, updatedProperties:any) => {
	return {
		...oldState,
		...updatedProperties
	};
}

export const compareString = (first:string,second:string) => {
	return first === second ? true : false;
};


export const insertBreakPoints = (data: any[], gapMinutes = 6) => {
  if (!data || data.length === 0) return [];
 
  const gapMs = gapMinutes * 60 * 1000;
  const len = data.length;
 
  const timestamps = new Array<number>(len);
  for (let i = 0; i < len; i++) {
    timestamps[i] = Date.parse(data[i].XAxisValue + "Z"); 
  }
  const result = new Array<{ x: Date; y: number | null }>(len * 2);
  let writeIdx = 0;
 
  for (let i = 0; i < len; i++) {
    result[writeIdx++] = {
      x: new Date(timestamps[i]),
      y: data[i].YAxisValue,
    };
 
    if (i < len - 1 && timestamps[i + 1] - timestamps[i] > gapMs) {
      result[writeIdx++] = {
        x: new Date(timestamps[i] + 1),
        y: null,
      };
    }
  }
 
  result.length = writeIdx;
  return result;
};